import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { CardButtons as CardButtonsStyled } from "./ApartmentsHelpers";

export const CardButtons = ({ apartmentId }) => {
    return (
        <CardButtonsStyled>
            <Button
                sx={{ mr: 2 }}
                variant="contained"
                component={Link}
                to={`/apartments/${apartmentId}/reports`}
            >
                Отчеты
            </Button>
            <Button
                variant="outlined"
                component={Link}
                to={`/apartments/${apartmentId}`}
            >
                Статистика
            </Button>
        </CardButtonsStyled>
    );
};
